import memoize from 'memoize-one';

import { isRunnerNone } from '../../App/interfaces/IRunners';

export const colorsWithoutNone = memoize((colors: ReadonlyArray<string>): ReadonlyArray<string> => {
    return colors.filter( (c) => !isRunnerNone(c));
});